import api from './api';
import ISettingsGet from './interfaces/common/ISettingsGet';

export default {
  settings: {
    get: async (): Promise<ISettingsGet> => api.get('/api/v1/settings'),
  },
};
